import { useEffect, useMemo, useState } from 'react';
import { LOGIN_BACKGROUND_IMAGES, LOGIN_BACKGROUND_INTERVAL_MS } from '@/lib/login-backgrounds.js';

export function LoginBackgroundSlideshow() {
  const [loaded, setLoaded] = useState<string[]>([]);
  const [active, setActive] = useState(0);

  const slides = useMemo(() => LOGIN_BACKGROUND_IMAGES.filter((src) => loaded.includes(src)), [loaded]);

  useEffect(() => {
    if (slides.length <= 1) return;

    const timer = window.setInterval(() => {
      setActive((prev) => (prev + 1) % slides.length);
    }, LOGIN_BACKGROUND_INTERVAL_MS);

    return () => window.clearInterval(timer);
  }, [slides.length]);

  useEffect(() => {
    if (active >= slides.length) setActive(0);
  }, [active, slides.length]);

  function markLoaded(src: string) {
    setLoaded((prev) => (prev.includes(src) ? prev : [...prev, src]));
  }

  return (
    <div
      aria-hidden
      style={{
        position: 'fixed',
        inset: 0,
        zIndex: 0,
        background: 'var(--bg)',
        overflow: 'hidden',
      }}
    >
      {LOGIN_BACKGROUND_IMAGES.map((src) => (
        <img key={src} src={src} alt="" onLoad={() => markLoaded(src)} style={{ display: 'none' }} />
      ))}

      {slides.map((src, index) => (
        <img
          key={`slide-${src}`}
          src={src}
          alt=""
          style={{
            position: 'absolute',
            inset: 0,
            width: '100%',
            height: '100%',
            objectFit: 'cover',
            objectPosition: 'center',
            opacity: index === active ? 1 : 0,
            transition: 'opacity 1s ease-in-out',
          }}
        />
      ))}

      {slides.length > 0 && (
        <div
          style={{
            position: 'absolute',
            inset: 0,
            background: 'linear-gradient(to bottom, rgba(0,0,0,0.72), rgba(0,0,0,0.85))',
          }}
        />
      )}
    </div>
  );
}
